module.exports = __webpack_public_path__ + "img/skills-summon-nec-2.d455384b.png";